"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateL1AllowedNodeIds = exports.filterChangedNodePaths = exports.getPathsFromProductTreeNodes = exports.shouldApplyAttributeFilter = exports.isSelectedAttributeList = void 0;
const product_tree_node_1 = require("../../client/product-tree-node");
const product_tree_nodes_1 = require("../../client/product-tree-nodes");
const store_1 = require("../../../store");
const isSelectedAttributeList = (selectedAttributes) => (Array.isArray(selectedAttributes) && selectedAttributes.length > 0);
exports.isSelectedAttributeList = isSelectedAttributeList;
const shouldApplyAttributeFilter = (selectedAttributes) => (selectedAttributes !== null && selectedAttributes !== 'ALL' && (0, exports.isSelectedAttributeList)(selectedAttributes));
exports.shouldApplyAttributeFilter = shouldApplyAttributeFilter;
const getPathsFromProductTreeNodes = (data) => { var _a; return ((0, product_tree_nodes_1.getTreeNodePaths)(((_a = data === null || data === void 0 ? void 0 : data.productTreeNodes.edges.map(({ node }) => node)) !== null && _a !== void 0 ? _a : []))); };
exports.getPathsFromProductTreeNodes = getPathsFromProductTreeNodes;
const filterChangedNodePaths = (nodePaths, showStrategyChanges, checkIsNodeChanged) => (showStrategyChanges ? nodePaths.filter(checkIsNodeChanged) : nodePaths);
exports.filterChangedNodePaths = filterChangedNodePaths;
const calculateL1AllowedNodeIds = (l1Id, selectedCategories, pathsData) => {
    // If this L1 is fully selected, don't filter its children
    const isFullySelected = selectedCategories.some((sel) => sel.value === l1Id && sel.allSelected);
    if (isFullySelected)
        return undefined;
    // If partially selected, build nodeIds from paths that belong to this L1
    const l1Paths = (pathsData || []).filter((path) => {
        const segments = path.split(store_1.STRATEGY_NODE_PATH_SEPARATOR);
        return segments[product_tree_node_1.L1_NODE_ANCESTOR_NUMBER] === l1Id; // Check if path belongs to this L1
    });
    if (l1Paths.length === 0)
        return undefined;
    const nodeIds = [];
    l1Paths.forEach((p) => {
        const segments = p.split(store_1.STRATEGY_NODE_PATH_SEPARATOR);
        segments.forEach((nodeId, idx) => {
            if (idx === 0)
                return; // Skip the ontology root
            if (!nodeIds.includes(nodeId)) {
                nodeIds.push(nodeId);
            }
        });
    });
    return nodeIds;
};
exports.calculateL1AllowedNodeIds = calculateL1AllowedNodeIds;
